import Header from '../../../Shared-Component/Header/Header'
import Footer from '../../../Shared-Component/Footer/Footer'
import computer from "../../../assets/CampuLifeImages/greencampus.JPG"
import CampusSlashTitle from '../../CampusSharedComponent/CampusTitles/CampusSlashTitle/CampusSlashTitle'
import CampusDynamicSection from '../../CampusSharedComponent/CampusSections/CampusDynamicSection/CampusDynamicSection'


const GreenCampus = () => {
     const libraryData = {
    img: computer,
    content: "Nooru Islam College is  an environmentally sustainable educational institution that integrates eco-friendly practices into its infrastructure, operations, and community activities to reduce its ecological footprint. It promotes conservation of natural resources, energy efficiency, waste reduction, and environmental awareness among students and staff, creating a healthy and sustainable learning environment.",
    listHeading:["Water Conservation : ","Waste Management : ","Green Landscaping : ","Eco Awareness & Transport : "], listItems:["Implementation of rainwater harvesting, water recycling, and awareness on saving water.",
      "Segregation of waste, composting of organic materials, and reduction of plastic use.",
      "Tree plantations, maintenance of green spaces, and promotion of biodiversity.",
      "Conducting environmental programs, promoting cycling, and using eco-friendly transport options.",
      ] 
  }

  return (
    <>
      <div>
        <Header />
        <div className='campusmaincontainer'>
          <div className='campus-container'>
            <CampusSlashTitle slashTitle="Green Campus" />
            <CampusDynamicSection data={libraryData} />
          </div>
          <Footer />
        </div>
      </div>

    </>
  )
}

export default GreenCampus